import * as jsyaml from 'js-yaml';

const cachedSpecs = {
  v1: null,
}

const rawYamlUrls = {
  v1: '/schemas/webhooks/webhooks-v1.yml',
}

/**
 * @param {string} version
 * @returns {Promise<object>}
 */
export async function getSpec(version) {
  if (cachedSpecs[version]) return cachedSpecs[version];

  const rawYamlUrl = rawYamlUrls[version];
  const res = await fetch(rawYamlUrl);
  const rawYaml = await res.text();

  // Parse YAML to object
  const schema = jsyaml.load(rawYaml);

  cachedSpecs[version] = schema;

  return schema;
}
